module.exports = __webpack_public_path__ + "static/Monosten-A-3ba13291f7becad101c4b2d389b831de.otf";